import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-between items-center gap-2 pt-7 md:pt-9 pb-4 md:pb-7 border-b border-b-neutral-900" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "flex items-center gap-1.5" }
const _hoisted_5 = { class: "flex justify-between items-center pt-5 mb-2" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = {
  key: 0,
  class: "leading-xl"
}
const _hoisted_8 = {
  key: 1,
  class: "flex gap-2 leading-xl"
}
const _hoisted_9 = { class: "flex justify-between items-center pb-5 border-b border-b-neutral-900" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "text-base-200" }
const _hoisted_12 = { class: "flex justify-between items-center py-8 md:py-11" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = {
  key: 0,
  class: "font-bold text-xl md:text-2xl leading-xl"
}
const _hoisted_15 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "flex flex-col gap-6" }
const _hoisted_18 = { class: "text-info-900 mb-1.5" }
const _hoisted_19 = { class: "text-info-900 list-disc pl-4" }

import { inject, ref } from 'vue';
import useBgImage from '../composables/useBgImage';
import { AppConfigType } from '../types';
import Toggle from '../components/form/Toggle.vue';
import Badge from '../components/base/Badge.vue';
import Button from '../components/base/Button.vue';
import Card from '../components/layout/Card.vue';
import ContainerSmall from '../components/layout/ContainerSmall.vue';
import usePopupWindow from '../composables/usePopupWindow';
import { useRouter } from 'vue-router';
import useSetPageTitle from '../composables/useSetPageTitle';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Upgrade',
  setup(__props) {

const { $gettext } = useGettext();

// Set page title
useSetPageTitle($gettext('Upgrade'));

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Router
const router = useRouter();

// Set backgroud image on body
useBgImage(config.plugin_url);

// Subscription type
// false - monthly; true - annually
const subscriptionType = ref(false);

// Open payment popup window
const openPaymentPopup = () => {
    usePopupWindow('https://app.boostsite.com/plugin/order-checkout/seo_plugin_plan', 1200, 800, () => {
        // Refresh the page
        router.go(0);
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContainerSmall, null, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        width: "139px",
        class: "max-md:mx-auto",
        src: `${_unref(config).plugin_url}/public/images/boostsite-logo.png`
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref($gettext)('Subscription')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Toggle, {
            "inactive-text": _unref($gettext)('monthly'),
            "active-text": _unref($gettext)('annually'),
            modelValue: subscriptionType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subscriptionType).value = $event))
          }, null, 8, ["inactive-text", "active-text", "modelValue"]),
          _createVNode(Badge, { type: "success" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($gettext)('15% OFF')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref($gettext)('Subtotal')), 1),
        (!subscriptionType.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "$24/" + _toDisplayString(_unref($gettext)('mo')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("del", { class: "text-base-200" }, "$288", -1)),
              _createElementVNode("p", null, "$240/" + _toDisplayString(_unref($gettext)('year')), 1)
            ]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref($gettext)('Tax')), 1),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref($gettext)('Enter address to calculate')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref($gettext)('Total due today')), 1),
        (!subscriptionType.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "$24.00"))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[2] || (_cache[2] = [
              _createElementVNode("del", { class: "text-base-200" }, "$288", -1),
              _createElementVNode("p", { class: "font-bold text-xl md:text-2xl leading-xl" }, "$240", -1)
            ])))
      ]),
      _createVNode(Button, {
        class: "w-full mb-10",
        text: _unref($gettext)('Proceed to payment'),
        size: "large",
        onClick: _withModifiers(openPaymentPopup, ["prevent"])
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(Card, {
          "image-url": `${_unref(config).plugin_url}/public/images/articles.png`,
          "image-alt": _unref($gettext)('Upgrade to premium plan'),
          type: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_unref($gettext)("With premium plan you'll get:")), 1),
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", null, _toDisplayString(_unref($gettext)('unlimited subjects & schedules')), 1),
                  _createElementVNode("li", null, _toDisplayString(_unref($gettext)(
                                        'up to 35 articles generated per week (with option to buy additional articles when needed)'
                                    )), 1),
                  _createElementVNode("li", null, _toDisplayString(_unref($gettext)('advanced scheduling')), 1),
                  _createElementVNode("li", null, _toDisplayString(_unref($gettext)('ability to add key words to every article')), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["image-url", "image-alt"])
      ])
    ]),
    _: 1
  }))
}
}

})